import {
  GlobalShoppingContextProps,
  ShoppingContextProps,
} from '@psl/flows/shop/types';
import { createContext, useContext } from 'react';

export const ShoppingContext = createContext<ShoppingContextProps>(null as any);

export const GlobalShoppingContext = createContext<GlobalShoppingContextProps>(
  null as any,
);

export const useShoppingContext = () => {
  return useContext(ShoppingContext);
};

export const useGlobalShoppingContext = () => useContext(GlobalShoppingContext);
